import React from 'react';

const FieldCheckbox = ({input, label, type}) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <div>
        <input {...input} type={type}/>
      </div>
    </div>
  );
};

export default FieldCheckbox;



// WEBPACK FOOTER //
// ./src/components/Field/FieldCheckbox.js